import { useMutation } from 'react-query';
import { ticketsService } from 'src/Utils/ticketsService';
import { SUCCESS_MESSAGES, ERROR_MESSAGES } from 'src/Utils/toastMessages';
import { showSuccessToast, showErrorToast } from 'src/Utils/toastHelper';
export var ARRANGEMENT_SUCCESS_MESSAGES = {
    payment_authorization: SUCCESS_MESSAGES.arrangements.payment_authorization,
    claim: SUCCESS_MESSAGES.arrangements.claim,
    budget_request: SUCCESS_MESSAGES.arrangements.budget_request,
    comment: SUCCESS_MESSAGES.arrangements.comment,
};
export var useCreateArrangement = function (_a) {
    var ticketId = _a.ticketId, onSuccess = _a.onSuccess, onError = _a.onError;
    var _b = useMutation(function (params) {
        return ticketsService.createArrangement(ticketId, {
            arrangement_type: params.arrangementType,
            authorized_by_id: params.authorizedById,
            provider_id: params.providerId,
            budget_request_id: params.budgetRequestId,
            internal_comment: params.internalComment,
            mentioned_admin_user_ids: params.mentionedAdminUserIds,
            files: params.files,
        });
    }, {
        onSuccess: function (_data, variables) {
            if (variables.arrangementType !== 'comment') {
                showSuccessToast(ARRANGEMENT_SUCCESS_MESSAGES[variables.arrangementType]);
            }
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(variables.arrangementType);
        },
        onError: function (error) {
            showErrorToast(error, ERROR_MESSAGES.arrangements.create);
            onError === null || onError === void 0 ? void 0 : onError(error);
        },
    }), mutateCreateArrangement = _b[0], isCreatingArrangement = _b[1].isLoading;
    return {
        mutateCreateArrangement: mutateCreateArrangement,
        isCreatingArrangement: isCreatingArrangement,
    };
};
